import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class LocationScreen extends React.Component {

    constructor(props) {
        super(props);

        var regionid = null;

        if (props.args.region)  {
            regionid = props.args.region
        }

        this.state = {regonOptions: [], 
                      regionid: regionid,    
                      currentLocation: {id: null, 
                                       name: "", 
                                       regionid: regionid,
                                       region: ""}};

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.handleChangeRegion = this.handleChangeRegion.bind(this);
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.location && this.props.args.location.length > 0) {
            BaseApi.get("/location", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.location}, withCredentials: true})
            .then(res => { 
                this.setState({currentLocation: res.data})
            })    
            .catch()
        }
 
        BaseApi.get("/regions", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => { 
            const regionOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({regionOptions: regionOptions})
        })    
        .catch()

        if (this.state.regionid) {
            BaseApi.get("/region", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.state.currentLocation.regionid}, withCredentials: true})
            .then(res => { 
                var region = res.data
                var currentLocation = this.state.currentLocation
                if (region) {
                    currentLocation.region = region.name
                    this.setState({сurrentLocation: currentLocation})
                }                     
            })   
            .catch()
        }    

    }


    save(event) {
        BaseApi.post('/location', this.state.currentLocation, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeName(event) {
        var currentLocation = this.state.currentLocation
        currentLocation.name = event.target.value
        this.setState({currentLocation: currentLocation})
    }

    handleChangeRegion(selectedOption) {
        var currentLocation = this.state.currentLocation
        currentLocation.region = selectedOption.label
        currentLocation.regionid = selectedOption.value
        this.setState({currentLocation: currentLocation})
    }

    openEvents() {
        this.props.navigate("events", 
        {caller: "location", callargs: this.props.args, locationid: this.state.currentLocation.id})
    }

    render() {

        const locationExists = this.state.currentLocation.id;

        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Населенный пункт"}/>

                <div className="row mt-4">
                    <div className="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {locationExists ? "Редактирование населенного пункта" : "Новый населенный пункт"}
                                </h6>
                                <form>
                                    <div class="form-group">
                                        <label for="name">Название:</label>
                                        <input type="text" class="form-control w-100" id="name" value={this.state.currentLocation.name} onChange={this.handleChangeName} />
                                        <label for="region">Регион:</label>
                                        {this.state.regionid === null && 
                                            <Select options= {this.state.regionOptions} 
                                                    id="region" 
                                                    onChange={this.handleChangeRegion}
                                                    placeholder={this.state.currentLocation.region}    
                                                    />
                                        }
                                        {this.state.regionid !== null &&  
                                            <input type="text" class="form-control w-100" id="region" value={this.state.currentLocation.region} readonly="readonly"/>      
                                        }
                                        <div className="mt-4 d-flex justify-content-end">
                                            <div class="row mt-3">
                                                <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                                            </div>
                                        </div>           
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>

                     <div className="col-lg-4 mt-4 mt-lg-0">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Действия</h6>

                                {locationExists && (
                                    <div>
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2" 
                                            onClick={()=>{this.openEvents()}}
                                        >
                                            События
                                        </button>   
                                    </div>
                                )
                                } 
                                 {!locationExists && (
                                    <p className="text-muted mb-0">
                                    Дополнительные действия станут доступны после сохранения записи.
                                    </p>
                                )}             

                            </div>
                        </div>
                    </div>    
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/location.js